import {getQuery, isEmpty, isNotEmpty} from "../../tools/utils";
import API from "../../apis";

let cacheSize = parseInt(localStorage.getItem('pageSize'))
const tableSet = {
    tableSet:{
        row_key:'FPRBILLNO',
        table_class: 'layout-table',
        height:'',
        dense: true,
        edit: false,
        isFullscreen:false,
        hidePagination: false,
        selected: [],
        selection: 'single',
        maxHeight: '',
        separator: 'cell', //表格边框
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 2, page: 1, search: '' },
        data:[],
        columns: [
            {name: 'FPRBILLNO',field: 'FPRBILLNO',label: '采购单号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'FDate',field: 'FDate',label: '采购日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
        ],
        visibleColumns: [],
        tools: {
            isShow:true,
            active_index: 1,
            buttons: []
        }
    },
    entryTableSet:{
        row_key:'ID',
        table_class: 'layout-table',
        loading:false,
        height:'',
        dense: true,
        edit: false,
        isFullscreen:false,
        hidePagination: false,
        // selected: [],
        // selection: 'single',
        maxHeight: '',
        separator: 'cell', //表格边框
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 2, page: 1, search: '' },
        data:[],
        columns: [
            {name: 'FPRBILLNO',field: 'FPRBILLNO',label: '采购申请单单号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FInterID',field: 'FInterID',label: '采购单内码',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'FEntryID',field: 'FEntryID',label: '行号',check: true,required: true, style: 'min-width: 60px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'FNumber',field: 'FNumber',label: '物料编码',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'MATNR',field: 'MATNR',label: '订货号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'FModel',field: 'FModel',label: '规格型号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            {name: 'FQTY',field: 'FQTY',label: '数量',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            {name: 'FDATE',field: 'FDATE',label: '采购申请制单日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},

            // {name: 'FPRBILLNO',field: 'FPRBILLNO',label: '采购申请单单号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FBillNo',field: 'FBillNo',label: '采购订单编号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FBillNoXS',field: 'FBillNoXS',label: '销售订单编号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'VBELN',field: 'VBELN',label: '施耐德发货单号（80号)',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FEntryID',field: 'FEntryID',label: '行号',check: true,required: true, style: 'min-width: 60px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FNumber',field: 'FNumber',label: '物料编码',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'MATNR',field: 'MATNR',label: '订货号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FModel',field: 'FModel',label: '规格型号',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FQTY',field: 'FQTY',label: '数量',check: true,required: true, style: 'min-width: 120px',align: 'right',sortable: true, format: (val) => `${val}`},
            // {name: 'FSupplyName',field: 'FSupplyName',label: '供应商名称',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FDATE',field: 'FDATE',label: '采购申请制单日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FPODATE',field: 'FPODATE',label: '采购订单制单日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FClosed',field: 'FClosed',label: '关闭标志',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FMrpClosed',field: 'FMrpClosed',label: '行业务关闭标志',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FStatus',field: 'FStatus',label: '单据状态',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FStockQty',field: 'FStockQty',label: '入库数量',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FAuxPriceDiscount',field: 'FAuxPriceDiscount',label: '实际含税单价',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FAllAmount',field: 'FAllAmount',label: '折扣率',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FTaxRate',field: 'FTaxRate',label: '价税合计',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FJQ',field: 'FJQ',label: '交货日期',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FExplanation',field: 'FExplanation',label: '采购订单备注',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
            // {name: 'FNote',field: 'FNote',label: '销售订单备注',check: true,required: true, style: 'min-width: 120px',align: 'left',sortable: true, format: (val) => `${val}`},
        ],
        visibleColumns: [],
        tools: {
            isShow:true,
            active_index: 1,
            buttons: []
        }
    },
}
const state = ()=>({
    purchaseRequisition:Object.assign({},tableSet)
})
const getters = {
    getTable:state => state.purchaseRequisition.tableSet,
    getEntryTable :state => state.purchaseRequisition.entryTableSet,
}
const mutations = {
    ['setEntryList'](state, data) {
        console.log(data,'datadata');
        state.purchaseRequisition.entryTableSet.data = data.data.data;
        state.purchaseRequisition.entryTableSet.pagination.count = data.data.count;
    },
    ['setTableHeight'](state, data){
        let height = data+60
        state.purchaseRequisition.entryTableSet.height = height + 'px';
    },
}
const actions = {
    ['getSoEntryList']({ state, commit ,dispatch},payload) {
        if (state.purchaseRequisition.entryTableSet.loading == true) return;
        let msg = {
            event: "command",
            data: {
                run: "read_purchase_entry",  //需要获取的数据方法
                query:payload
            }
        };
        dispatch('channel/socket_send', msg, { root: true })
        state.purchaseRequisition.entryTableSet.loading = true
    },
    ['setEntryList']({ state, commit ,dispatch},payload) {
        state.purchaseRequisition.entryTableSet.loading = false;
        commit('setEntryList',payload.result);
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
